import React from 'react';
import { motion } from 'framer-motion';
export function ProductImage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="w-full flex flex-col items-center" data-id="element-20">
      <div className="w-full rounded-2xl overflow-hidden shadow-xl border border-slate-100 bg-slate-50" data-id="element-21">
        <img src="https://cdn.magicpatterns.com/uploads/dGSwADAJUc914rShBEcnKL/pasted-image.png" alt="Proveedor de productos en tendencias" className="w-full h-auto object-cover" data-id="element-22" />
      </div>
      <p className="mt-4 text-sm text-slate-500 font-medium italic" data-id="element-23">
        Acceso completo al Proveedor de Tendencias
      </p>
    </motion.div>;
}